<template>
  <div class="modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">앱미터기 {{ placehold.officeId ? "수정" : "추가" }}</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
          <div class="info-div">
            <table class="info-table">
              <tbody>
              <tr>
                <th>단말전화번호</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.mdn" :placeholder="placehold.mdn"/>
                </td>
                <th>사업자명</th>
                <td>
                  <div class="d-flex align-items-center">
                    <kona-input class="form-control w-150" v-model="appmeterDto.officeNm" :disabled="true"
                                :placeholder="placehold.officeNm"></kona-input>
                    <BIconPlusSquareFill @click="openSearchPartnerModal(true)"
                                         style="font-size: 35px; margin-left: 6px;"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th>차량번호</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.carNum"
                              :placeholder="placehold.carNum"></kona-input>
                </td>
                <th>차대번호</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.carVin"
                              :placeholder="placehold.carVin"></kona-input>
                </td>
              </tr>
              <tr>
                <th>자격면허번호</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.license"
                              :placeholder="placehold.license"></kona-input>
                </td>
                <th>지역</th>
                <td>
                  <kona-select class="form-select w-150" :options="regionTypeEnum"
                               @change="selectEvents($event, 'regionType')"></kona-select>
                </td>
              </tr>
              <tr>
                <th>유형</th>
                <td>
                  <kona-select class="form-select w-150" :options="carTypeEnum"
                               @change="selectEvents($event, 'carType')"></kona-select>
                </td>
                <th>단말 시리얼 번호</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.unitSn"
                              :placeholder="placehold.unitSn"></kona-input>
                </td>
              </tr>
              <tr>
                <th>속도 감속률</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.speedDownRatio"
                              :placeholder="placehold.speedDownRatio"></kona-input>
                </td>
                <th>RPM 감속률</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.rpmDownRatio"
                              :placeholder="placehold.rpmDownRatio"></kona-input>
                </td>
              </tr>
              <tr>
                <th>거리보정</th>
                <td>
                  <kona-input class="form-control w-150" v-model="appmeterDto.distCorrection"
                              :placeholder="placehold.distCorrection ? placehold.distCorrection.toString() : ''"></kona-input>
                </td>
                <th>등록일</th>
                <td><input class="form-control" type="date" v-model="appmeterDto.regDt"/></td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Close</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="clickSaveBtn">Save</button>
        </div>
      </div>
    </div>
    <SearchPartnerModal v-if="searchPartnerModalOpenClose" @selectPartner="initPartner"
                        @close="openSearchPartnerModal(false)"/>
  </div>
</template>

<script setup>
import {defineProps, ref} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import SearchPartnerModal from "@/components/tacho/component/SearchPartnerModal.vue";
import {BIconPlusSquareFill} from "bootstrap-icons-vue"

const props = defineProps({
  type: String,
  placehold: Object
})
const emit = defineEmits(['close', 'getList', 'add', 'modify']);

const store = useStore();
const url = tachoEntity.baseUrl;
const appmeterDto = new tachoEntity.appmeterDto();

const carTypeEnum = [props.placehold.carType || '선택', ...Object.values(tachoEntity.appmeterCarTypeEnum).filter(v => v !== props.placehold.carType)];
const regionTypeEnum = [props.placehold.region || '선택', ...Object.values(tachoEntity.regionTypeEnum).filter(v => v !== props.placehold.region)];

appmeterDto.speedDownRatio = "5120";
appmeterDto.rpmDownRatio = "2000";
appmeterDto.distCorrection = "2";
appmeterDto.carType = carTypeEnum[0];
appmeterDto.region = regionTypeEnum[0];

const selectEvents = (event, select) => {
  switch (select) {
    case 'regionType': {
      appmeterDto.region = event.target.value;
      break;
    }
    case 'carType': {
      appmeterDto.carType = event.target.value;
      break;
    }
  }
}

const addAppmeter = async () => {
  if (!appmeterDto.mdn || !appmeterDto.officeId || !appmeterDto.carNum || !appmeterDto.carVin || !appmeterDto.license || !appmeterDto.unitSn || !appmeterDto.regDt || !appmeterDto.region || !appmeterDto.carType || !appmeterDto.officeNm || appmeterDto.carType === "선택" || appmeterDto.region === "선택") {
    return store.commit("openMessageBox", "필수값을 모두 입력해 주세요.");
  }

  try {
    await axios.$post(`${url}/appmeter`, appmeterDto);
    emit('getList');
    emit('close');
  } catch (err) {
    store.commit("openMessageBox", err);
  }
}

const modifyAppmeter = async () => {
  for (const key in appmeterDto) {
    appmeterDto[key] = appmeterDto[key] === undefined ? props.placehold[key] : appmeterDto[key];
  }

  if (!appmeterDto.mdn || !appmeterDto.officeId || !appmeterDto.carNum || !appmeterDto.carVin || !appmeterDto.license || !appmeterDto.unitSn || !appmeterDto.speedDownRatio || !appmeterDto.rpmDownRatio || !appmeterDto.distCorrection || !appmeterDto.regDt || !appmeterDto.region || !appmeterDto.carType || !appmeterDto.officeNm) {
    return store.commit("openMessageBox", "필수값을 모두 입력해 주세요.");
  }

  try {
    await axios.$put(`${url}/appmeter/${props.placehold.appmeterId}`, appmeterDto);
    emit('getList');
    emit('close');
  } catch (err) {
    store.commit("openMessageBox", err);
  }
}


const searchPartnerModalOpenClose = ref(false),
    openSearchPartnerModal = (openClose) => searchPartnerModalOpenClose.value = openClose;

const initPartner = (selectPartner) => {
  appmeterDto.officeId = selectPartner.officeId;
  appmeterDto.officeNm = selectPartner.name;
}

const clickSaveBtn = () => {
  if (props.type === "modify") {
    modifyAppmeter()
  } else {
    addAppmeter()
  }
}

</script>

<style scoped>
.modal-dialog {
  font-size: 0.8rem;
  min-width: 50rem;
}

.modal-body {
  padding: 0;
}

.inner-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.inner-top button {
  border: none;
  padding: 0.25rem 2rem;
  margin: 5px;
  font-size: 13px;
  color: #ffffff;
  background-color: #000000;
}

/* .inner-top,
.info-div{
  padding: 10px;
}
.info-div{
  margin: 0 0  1.5rem 0;
} */
.info-table {
  width: 100%;
}

.info-table tr {
  border-bottom: 1px solid var(--bs-modal-header-border-color);
}

.info-table tr:last-child {
  border: none;
}

.info-table th,
.info-table td {
  text-align: left;
  padding: 0.4rem 0.5rem !important;
}

.info-table th {
  background-color: rgba(248, 249, 250);
  width: 20%;
}

.info-table td {
  width: 30%;
}

.info-table td input,
.info-table td select {
  font-size: 13px;
}

button {
  color: #ffffff;
}

</style>
